import { render, staticRenderFns } from "./CampusDynamic.vue?vue&type=template&id=ca1bcd5e&scoped=true"
import script from "./CampusDynamic.vue?vue&type=script&lang=js"
export * from "./CampusDynamic.vue?vue&type=script&lang=js"
import style0 from "./CampusDynamic.vue?vue&type=style&index=0&id=ca1bcd5e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1bcd5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1bcd5e')) {
      api.createRecord('ca1bcd5e', component.options)
    } else {
      api.reload('ca1bcd5e', component.options)
    }
    module.hot.accept("./CampusDynamic.vue?vue&type=template&id=ca1bcd5e&scoped=true", function () {
      api.rerender('ca1bcd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/CampusDynamic.vue"
export default component.exports